import React from 'react';
import { history } from 'store/configureStore';
import { ListGroup } from 'react-bootstrap';
import * as style from 'styles/util';
import styled from 'styled-components';

/**
 * ログイン前画面
 */
const PreLogin = () => {
  const handleLogin = () => {
    history.replace({
      pathname: '/start',
      state: { 
        fromPrelogin: true,
      }
    });
  };

  return (
    <div className="col-12 pl-0 pr-0 bg-gray">
      <style.SimpleHead>Back-office Web system of OTA server</style.SimpleHead>
      <div className="col-8 col-lg-6 mx-auto">
        <ListGroup>
          <Button onClick={() => handleLogin()} className="list-group-item list-group-item-action">Log in</Button>
        </ListGroup>
      </div>
    </div>
  );
};

const Button = styled.button`
  :focus {
    outline:none;
  }
`;
export default PreLogin;
